import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Alert, Dialog, DialogActions, DialogContent, Password } from '@guildeducationinc/recess';
import { UPDATE_PROFILE } from '@src/graphql/queries/user';
import { useAuth } from '@src/hooks/useAuth';
import { prepareForSave } from '@src/utilities/gqlHelper';
import { omit } from 'lodash';
import { TrackableButton, useAlert, useLocale } from 'pe-core-frontend';
import { useState } from 'react';
import styles from './ChangePasswordModal.module.scss';
export const ChangePasswordModal = ({ isOpen, onClose }) => {
    const { currentUser } = useAuth();
    const { t } = useLocale();
    const { showAlert } = useAlert();
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);
    const [updateProfile] = useMutation(UPDATE_PROFILE);
    const handleClose = () => {
        setPassword('');
        setNewPassword('');
        setError('');
        setSaving(false);
        onClose();
    };
    const handleSave = async () => {
        if (password !== newPassword) {
            setError(t('Passwords do not match'));
            return;
        }
        try {
            setSaving(true);
            const result = await updateProfile({
                variables: {
                    input: {
                        ...omit(prepareForSave(currentUser), 'employeeId', 'clientInfo', 'phone', 'permissions', 'roleNames', 'uniqueId'),
                        password: newPassword,
                    },
                },
            });
            if (result.data) {
                if (result.data.updateProfile.validationErrors) {
                    setError(t(result.data.updateProfile.validationErrors[0].message));
                    return;
                }
                if (result.data.updateProfile.error) {
                    setError(t(result.data.updateProfile.error));
                    return;
                }
            }
            showAlert(t('Password updated'));
            // Save password
            handleClose();
        }
        catch (e) {
            setError(e.message);
        }
        finally {
            setSaving(false);
        }
    };
    return (_jsxs(Dialog, { isOpen: isOpen, onClose: handleClose, title: t('Change Password'), size: 'sm', fullScreen: true, children: [_jsxs(DialogContent, { className: styles.content, children: [_jsx(Alert, { hideClose: true, display: true, type: 'info', className: 'margin--bottom_24', children: _jsx("div", { className: styles.passwordPolicy, children: t('Password policy details') }) }), error && (_jsx(Alert, { display: true, hideClose: true, type: 'danger', children: error })), _jsx(Password, { label: t('New Password'), value: password, onChange: e => setPassword(e.target.value) }), _jsx(Password, { label: t('Confirm Password'), value: newPassword, onChange: e => setNewPassword(e.target.value) })] }), _jsxs(DialogActions, { fullScreen: true, children: [_jsx(TrackableButton, { enText: 'Cancel', tag: 'change_password_modal', appearance: 'outline', onClick: handleClose, disabled: saving, children: t('Cancel') }), _jsx(TrackableButton, { enText: 'Save', tag: 'change_password_modal', disabled: saving, onClick: handleSave, children: t('Save') })] })] }));
};
